import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ValOrDash from "../../components/ValOrDash";
import EmailList from "../../components/EmailList";
const CustomerDefinitionList = ({ customer }) => {
    return (_jsxs("dl", { children: [_jsx("dt", { children: "Code" }), _jsx("dd", { children: _jsx(ValOrDash, { val: customer?.code }) }), _jsx("dt", { children: "Name" }), _jsx("dd", { children: _jsx(ValOrDash, { val: customer?.name }) }), _jsx("dt", { children: "POD Email Addresses" }), _jsx("dd", { children: _jsx(ValOrDash, { val: _jsx(EmailList, { emails: customer?.podEmailCsv }) }) })] }));
};
export default CustomerDefinitionList;
